export function scrollToTop() {
  // add 200 delay to prevent call it when is scrolling
  window.setTimeout(() => window.scrollTo(0, 0), 200);
}

export function scrollToEle(ele: HTMLElement | null) {
  if (!ele) return;
  window.setTimeout(() => ele.scrollIntoView(), 200);
}
